import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import * as BaseStyles from '../DataUpload.styles';
import * as Styles from './DataUploadMenuLink.styles';

interface DataMenuLinkParams {
  path: string;
  text: string;
  startIcon: JSX.Element;
}

const DataMenuLink: FC<DataMenuLinkParams> = ({ path, text, startIcon }) => {
  const location = useLocation();
  const isActive = location.pathname === path;

  return (
    <Styles.UploadLink to={path}>
      <BaseStyles.DataButton variant={'contained'} startIcon={startIcon} disabled={isActive}>
        {text}
      </BaseStyles.DataButton>
    </Styles.UploadLink>
  );
};

export default DataMenuLink;
